/**
 * Import blocks
 */

import './shortcode/index';
import './block/index';
